document.addEventListener('DOMContentLoaded', function (){

    document.querySelector('.online-chat__head').addEventListener('click', function (){
        this.classList.toggle('active');
        document.querySelector('.online-chat__body').classList.toggle('active');
    })
});

// personalization functions
document.addEventListener('DOMContentLoaded', function (){
    let personalizationTextBlock, personalizationText;

    // personalization on product page
    if (document.querySelector('.product-page-wrapper .product-detail__personalization_text')){
        setPersonalization();
    }

    function setPersonalization(){
        personalizationTextBlock = document.querySelector('.product-detail__personalization_text');
        personalizationText = document.querySelector('#personalization-info');
        let productOptions = document.querySelectorAll('.product-form__option');

        productOptions.forEach(function (item){
            let optionLabel = item.querySelector('.product-form__option-label').innerText;
            if (optionLabel.includes('Size')) {
                let optionSelect = item.querySelector('.product-form__option-select');

                if (optionSelect.value === 'Custom') {
                    personalizationTextBlock.classList.add('active');
                }

                personalizationListener(optionSelect);
            } else {
                // listen another option
                let optionSelect = item.querySelector('.product-form__option-select');
                listenAnotherOption(optionSelect)
            }
        })
    }

    function listenAnotherOption(optionSelect) {
        optionSelect.addEventListener('change', function (){
            setTimeout(function (){
                checkPersonalizationField();
            }, 100);
        })
    }

    // listen change size option
    function personalizationListener(optionSelect){

        optionSelect.addEventListener('change', function (event){
            if (event.target.value.toLowerCase() === 'custom') {
                personalizationTextBlock.classList.add('active');
            } else {
                personalizationTextBlock.classList.remove('active');
            }

            setTimeout(function (){
                checkPersonalizationField();
            }, 100);
        })

        // Listen personalizationText
        personalizationText.addEventListener('input', function (event) {
            checkPersonalizationField();
        });

        checkPersonalizationField();
    }

    function isEmptyPersonalizationField() {
        if (personalizationText.value.length < 10) {
            return true;
        } else {
            return false;
        }
    }

    // disable button if field empty
    function checkPersonalizationField() {
        let buttons = document.querySelectorAll('.product-form__item--submit button');

        if (personalizationTextBlock.classList.contains('active')) {
            if (isEmptyPersonalizationField()) {
                buttons.forEach(function (item){
                    item.setAttribute('disabled', 'disabled');
                    personalizationTextBlock.classList.add('error');
                })
            } else {
                buttons.forEach(function (item){
                    item.removeAttribute('disabled');
                    personalizationTextBlock.classList.remove('error');
                })
            }
        }
    }

    // Color swatches change color label
    if (document.querySelector('.product-form__option[data-option="color"]')){
        swatchesChangeColorLabel();
    }

    function swatchesChangeColorLabel() {
        let buttons = document.querySelectorAll('.product-form__option[data-option="color"] .product-form__color-swatch');

        buttons.forEach(function (button){
            button.addEventListener('click', function (item){
                let buttonValue = this.dataset.color;
                this.closest('.product-form__color-swatches').querySelector('.product-form__option-selected').innerText = buttonValue;
            })
        })
    }

    // Custom order popup
    if (document.querySelector('.product-form__controls-group') && document.querySelector('.custom-order-popup')){
        customOrderPopupListener();
    }

    function customOrderPopupListener() {
        let optionSelects = document.querySelectorAll('.product-form__option-select');

        optionSelects.forEach(function (item) {
            item.addEventListener('change', function (){
                if (this.value === 'Custom') {
                    document.querySelector('.custom-order-popup').classList.add('active');
                }
            })
        });

        document.querySelector('.custom-order-popup__close').addEventListener('click',function (){
            document.querySelector('.custom-order-popup').classList.remove('active');
        });
    }

    /// quick shop listeners

    if (document.querySelector('.product-item__quick-shop-button') && document.querySelector('.custom-order-popup')){
        let quickShopButtons = document.querySelectorAll('.product-item__quick-shop-button');

        quickShopButtons.forEach(function (item){
            item.addEventListener('click', function (){
                let quickAddLoadingObseerver = new MutationObserver(function (mutations) {
                    mutations.forEach(function (mutation) {
                        if (mutation.attributeName === 'class' && mutation.target.classList.contains('loaded')) {
                            swatchesChangeColorLabel();
                            customOrderPopupListener();
                            quickAddLoadingObseerver.disconnect();
                        }
                    });
                });

                quickAddLoadingObseerver.observe(document.querySelector('.quick-add'), {
                    attributes: true,
                    attributeOldValue: true
                });
            })
        })
    }
})